import { useRef } from 'react';
import * as moment from 'moment';
import { ColumnApi, CsvExportParams, GridApi, GridReadyEvent } from 'ag-grid-community';

export default function useExportHardToMatchPairs() {
    const gridApiRef = useRef<GridApi>(null);
    const columnApiRef = useRef<ColumnApi>(null);

    const onGridReady = (e: GridReadyEvent) => {
        gridApiRef.current = e.api;
        columnApiRef.current = e.columnApi;
    };

    const exportHardToMatchPairs = () => {
        if (!gridApiRef.current) return;

        const params: CsvExportParams = {
            fileName: `hard-to-match-pairs-${moment().format('YYYY-MM-DD')}.csv`,
            columnKeys: columnApiRef.current.getAllDisplayedColumns().filter(x => x.getColId() != 'action')
        };

        gridApiRef.current.exportDataAsCsv(params);
    };

    return { onGridReady, exportHardToMatchPairs };
}
